// Starter books shown on the Library page before any are added from the admin panel.
// Once a book exists in Firestore (Admin → Books) this list is ignored.
export const books = [
  {
    id: 'starter-drpulse-clinical',
    slug: 'rapid-clinical-medicine-notes',
    title: 'Dr. Pulse Rapid Clinical Medicine & Ward Survival Notes',
    author: 'Dr. Pulse Editorial Board',
    edition: '2025 Edition',
    category: 'Clinical Medicine',
    description: 'High-yield bedside clinical pearls, emergency management protocols, rapid ECG & ABG interpretation, and essential drug dosages for wards and exams.',
    price: '₹199.00',
    amountPaise: 19900,
    currency: 'INR',
    image: '',
    amazonUrl: '',
    kindleUrl: '',
    pdfUrl: '',
    libraryType: 'original',
    paymentEnabled: true,
    active: true,
    rating: 5.0,
    reviewCount: 0,
  },
  {
    id: 'starter-drpulse-pharma',
    slug: 'high-yield-pharmacology-flowcharts',
    title: 'High-Yield Pharmacology & Mechanism Flowcharts',
    author: 'Dr. Pulse Academic Team',
    edition: '3rd Edition',
    category: 'Pharmacology',
    description: 'Visual mechanism flowcharts, drug classifications, adverse effect mnemonics, and USMLE/NEET-PG high-yield questions for fast revision.',
    price: '₹149.00',
    amountPaise: 14900,
    currency: 'INR',
    image: '',
    amazonUrl: '',
    kindleUrl: '',
    pdfUrl: '',
    libraryType: 'original',
    paymentEnabled: true,
    active: true,
    rating: 5.0,
    reviewCount: 0,
  },
  {
    id: 'starter-guyton',
    slug: 'guyton-medical-physiology',
    title: 'Guyton and Hall Textbook of Medical Physiology',
    author: 'John E. Hall',
    edition: '14th Edition',
    category: 'Physiology',
    description: 'The classic physiology text — clear explanations of every system, built for exam preparation and clinical understanding.',
    price: '',
    image: '',
    amazonUrl: 'https://www.amazon.com/',
    kindleUrl: '',
    pdfUrl: '',
    libraryType: 'external',
    active: true,
    rating: 4.9,
    reviewCount: 342,
  },
  {
    id: 'starter-grays',
    slug: 'grays-anatomy-for-students',
    title: "Gray's Anatomy for Students",
    author: 'Richard Drake, A. Wayne Vogl, Adam Mitchell',
    edition: '5th Edition',
    category: 'Anatomy',
    description: 'Student-focused anatomy with clinical correlations and illustrations mapped to how anatomy is actually taught and examined.',
    price: '',
    image: '',
    amazonUrl: 'https://www.amazon.com/',
    kindleUrl: '',
    pdfUrl: '',
    libraryType: 'external',
    active: true,
    rating: 4.8,
    reviewCount: 215,
  },
  {
    id: 'starter-harrisons',
    slug: 'harrisons-principles-of-internal-medicine',
    title: "Harrison's Principles of Internal Medicine",
    author: 'Joseph Loscalzo et al.',
    edition: '21st Edition',
    category: 'Internal Medicine',
    description: 'The reference standard for internal medicine — pathophysiology, diagnosis, and management across every specialty.',
    price: '',
    image: '',
    amazonUrl: 'https://www.amazon.com/',
    kindleUrl: '',
    pdfUrl: '',
    libraryType: 'external',
    active: true,
    rating: 4.9,
    reviewCount: 489,
  },
];

export default books;
